/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Colors, Margins, Responsive } from 'src/design-system/style-types';

import { style } from './Avatar.style';
import { IconName } from '../Icon/Icon.types';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import { ReactNode } from 'react';

export interface Props {
  name?: string;
  size: 'xs' | 'sm' | 'md' | 'lg' | '5xl';
  src?: string;
  marginBottom?: Responsive<Margins>;
  marginRight?: Responsive<Margins>;
  marginLeft?: Responsive<Margins>;
  border?: Responsive<boolean | Colors>;
  shadow?: Responsive<boolean>;
  colorCode?: Colors;
  className?: string;
  overlayIcon?: IconName;
  toolTipText?: ReactNode;
}

const getInitials = (name?: string) => {
  const names = name?.split(' ') ?? [''];
  let initials = names?.[0]?.substring(0, 1)?.toUpperCase();
  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};

export const Avatar = ({
  name,
  size,
  src = '',
  marginBottom = '0',
  marginRight = '0',
  marginLeft = '0',
  border = false,
  shadow = false,
  colorCode,
  className,
  overlayIcon,
  toolTipText,
}: Props) => {
  let initials = getInitials(name);

  if (size === 'xs' || size === 'sm') {
    initials = initials.charAt(0);
  }

  const avatar = (
    <div
      aria-label="accountAvatar"
      className={className}
      css={style.avatar({ name, size, src, marginBottom, marginRight, marginLeft, border, shadow, colorCode })}
    >
      <span>{!src && initials}</span>
      {overlayIcon && <Icon name={overlayIcon} css={{ position: 'absolute', bottom: '-3px', right: '-3px' }} />}
    </div>
  );

  if (toolTipText) {
    return <Tooltip button={avatar}>{toolTipText}</Tooltip>;
  } else {
    return avatar;
  }
};
